import { IconCheck } from "@tabler/icons-react";
import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";

export enum AddContractItemSteps {
  PURCHASE_INFORMATION = "Purchase Information",
  UPLOAD_INVOICE = "Upload Invoice",
  CUSTOMER_INFORMATION = "Customer Information",
  STORE_INFORMATION = "Store Information",
  LINE_ITEM_INFORMATION = "Line Item Information",
  SUCCESS = "Success",
}

export const AddContractSteps = [
  {
    step: 1,
    label: AddContractItemSteps.UPLOAD_INVOICE,
  },
  {
    step: 2,
    label: AddContractItemSteps.PURCHASE_INFORMATION,
  },
  {
    step: 3,
    label: AddContractItemSteps.CUSTOMER_INFORMATION,
  },
  {
    step: 4,
    label: AddContractItemSteps.STORE_INFORMATION,
  },
  {
    step: 5,
    label: AddContractItemSteps.LINE_ITEM_INFORMATION,
  },
  {
    step: 6,
    label: AddContractItemSteps.SUCCESS,
    stepElement: <IconCheck />,
  },
];

export interface StepsProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  register: UseFormRegister<FieldsType>;
  watch: UseFormWatch<FieldsType>;
}
